export default __webpack_public_path__ + "static/media/map-pin-full.52c16272.svg";